<div style="height: 60px" class="hide-on-desktop"></div>